"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var React = require("react");

var palette_1 = require("../../constants/palette");

var phone_1 = require("../../utils/phone");

var FlexAddress = styled_components_1.default.address(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 300px;\n  font-size: 13px;\n  text-align: right;\n  font-style: normal;\n  color: ", ";\n  line-height: 1.4;\n  a {\n    color: ", ";\n    text-decoration: none;\n    font-weight: 600;\n  }\n"], ["\n  width: 300px;\n  font-size: 13px;\n  text-align: right;\n  font-style: normal;\n  color: ", ";\n  line-height: 1.4;\n  a {\n    color: ", ";\n    text-decoration: none;\n    font-weight: 600;\n  }\n"])), palette_1.default.darkGrey, palette_1.default.darkGrey);

var NavLocationInfo = function NavLocationInfo(props) {
  return React.createElement(FlexAddress, null, props.address1, React.createElement("br", null), props.address2 && React.createElement("span", null, props.address2, React.createElement("br", null)), props.city, ", ", props.state, " ", props.zip, React.createElement("br", null), props.phoneNumber && React.createElement("a", {
    href: "tel:" + props.phoneNumber
  }, phone_1.formatPhoneNumber(props.phoneNumber)));
};

exports.default = NavLocationInfo;
var templateObject_1;